var map = {
	"./1.png": 5933,
	"./10.png": 3996,
	"./11.png": 3437,
	"./12.png": 5382,
	"./13.png": 4811,
	"./2.png": 7827,
	"./3.png": 2844,
	"./4.png": 6960,
	"./5.png": 6436,
	"./6.png": 7770,
	"./7.png": 5766,
	"./8.png": 6770,
	"./9.png": 9793
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 150;